import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

export const Message = defineMessageUnion({
	ClickedToggle: {},
	CompletedJingle: {},
	/** From the session Subscription: the data channel opened at `at` (ms). */
	SessionConnected: { id: S.String, at: S.Number },
	SessionFailed: { id: S.String, error: S.String },
	/** The model asked for a function call; `args` is the raw JSON string it sent. */
	ToolCalled: {
		id: S.String,
		callId: S.String,
		name: S.String,
		args: S.String,
	},
	CompletedTool: {
		id: S.String,
		callId: S.String,
		name: S.String,
		success: S.Boolean,
		details: S.String,
		output: S.String,
		timestamp: S.String,
	},
	CompletedSendToolResult: {},
	Ticked: { now: S.Number },
});
export type Message = typeof Message.Type;
